import { filter, get, isEmpty } from 'lodash';
import { connect } from 'react-redux';

import Pdp from 'components/Pdp';
import { TYPES } from 'constants/merchandising';
import {
  CAMPAIGN_IDENTIFIERS,
  CAMPAIGN_NAMES,
  RETURNS_MESSAGING_ATTRIBUTE,
} from 'constants/personalizations';
import { SHOP_IDS } from 'constants/shops';
import { TEST_PDPS } from 'containers/UnisexPdpSelectorContainer/constants';
import * as actions from 'state/actions';
import { getStoreLocationContentByHandle } from 'state/selectors/contentful';
import ExperimentsSelector from 'state/selectors/experiments';
import {
  getCurrentProduct,
  getCurrentVariant,
  getCurrentSizeRecommendation,
  isSalePdp,
  getExperimentImagesPdp,
} from 'state/selectors/pdp';
import PersonalizationsSelector from 'state/selectors/personalizations';
import Rudderstack from 'utils/Rudderstack';
import Settings from 'utils/Settings';

const mapStateToProps = (state, ownProps) => {
  const product = getCurrentProduct(state);
  const currentVariant = getCurrentVariant(state);

  const pdpStorytellingEnabled = ownProps.features?.pdpStorytellingEnabled;

  const { enableDiscountPriceColor, yotpoEnabled } = Settings;

  const showAfterpayAboveReviewsStars =
    Settings.pdpAfterpayEnabled && ExperimentsSelector.showAfterpayAboveReviewsStars(state);

  const sizingRecommendation = getCurrentSizeRecommendation(state);

  const showUnisexButton =
    ExperimentsSelector.isPdpUnisexToggleEnabled(state) &&
    !isEmpty(TEST_PDPS[product.master]) &&
    !isSalePdp();

  const showShoprunner = get(product, 'isShoprunnerEnabled') && Settings.shoprunnerEnabled;

  const showFreeShippingMessage = Settings.freeShippingEnabled;

  const storeLocationContent = getStoreLocationContentByHandle(state);
  const showPdpStoreInventoryFeature =
    Settings.storeInventoryEnabled &&
    product.type !== TYPES.GIFT_CARDS &&
    (Settings.shopID == SHOP_IDS.US || Settings.shopID == SHOP_IDS.UK);
  const showPdpStoreInventory =
    showPdpStoreInventoryFeature &&
    storeLocationContent &&
    Object.keys(storeLocationContent).length > 0;

  const testImagesDataCampaign = PersonalizationsSelector.getCampaignByName(
    state,
    CAMPAIGN_NAMES.PDP_IMAGES_EXPERIMENT
  );
  const dyExperimentImageData = getExperimentImagesPdp(state, testImagesDataCampaign);
  if (dyExperimentImageData?.length > 0) {
    product.images = dyExperimentImageData;
  }

  const additionalSizingRecommendationCampaign = PersonalizationsSelector.getCampaignByName(
    state,
    CAMPAIGN_NAMES.PDP_ADDITIONAL_SIZE_GUIDANCE
  );
  const additionalSizingRecommendationVariation =
    additionalSizingRecommendationCampaign?.variations?.[0];
  const additionalSizingRecommendation =
    additionalSizingRecommendationVariation?.payload?.data?.label;

  const belowTheFoldStoryModuleCampaign = PersonalizationsSelector.getCampaignByName(
    state,
    CAMPAIGN_NAMES.PDP_BTF_STORY_MODULE
  );
  const belowTheFoldStoryModuleVariation = belowTheFoldStoryModuleCampaign?.variations?.[0];
  const showNewBelowTheFoldStoryModule =
    belowTheFoldStoryModuleVariation?.payload?.data?.[CAMPAIGN_IDENTIFIERS.PDP_BTF_STORY_MODULE];

  // Mini Nav DY Targeting
  const miniNavigationOptions =
    ExperimentsSelector.experimentOptions(state, 'miniNavigation') || [];
  const miniNavigationItems = (miniNavigationOptions.navLinks || []).filter(
    item => item.text && item.url
  );

  // TODO: This is temporary for the PDP Storytelling feature and will need to be removed when the test is over
  let attributes = pdpStorytellingEnabled
    ? filter(
        ownProps.attributes,
        attribute => !['details', 'sustainability'].includes(attribute.header.toLowerCase())
      )
    : filter(
        ownProps.attributes,
        attribute =>
          !['innovations', 'fit & alternative sizing', 'size & fit guidance'].includes(
            attribute.header.toLowerCase()
          )
      );

  // Easy Returns DY Targeting
  const easyReturnsVariationData = PersonalizationsSelector.getCampaignVariationData(
    state,
    CAMPAIGN_NAMES.MULTI_TOUCH_RETURNS_MESSAGING
  );
  const showEasyReturns = easyReturnsVariationData?.payload?.data?.enabled;
  let addToCartPolicyText = ownProps.addToCartPolicyText || '';

  if (showEasyReturns && addToCartPolicyText) {
    addToCartPolicyText = addToCartPolicyText.replace('Free returns.', 'Easy returns.');
    attributes = attributes.map(attribute => {
      if (attribute.header.toLowerCase() === 'shipping & returns') {
        return RETURNS_MESSAGING_ATTRIBUTE;
      }
      return attribute;
    });
  }

  const pdpStorytellingModuleOrder = [
    'story-module-0',
    'attributes',
    'ugc-carousel',
    'card-carousel',
    'brand-tenets',
    'reviews',
    'pdp-recs-carousel',
  ];

  return {
    ...ownProps,
    addToCartPolicyText,
    attributes,
    currentVariant,
    features: {
      ...ownProps.features,
      showAfterpayAboveReviewsStars,
      showUnisexButton,
      showShoprunner,
      enableDiscountPriceColor,
      showFreeShippingMessage,
      showPdpStoreInventory,
      showNewBelowTheFoldStoryModule,
      yotpoEnabled,
    },
    miniNavigationItems,
    pdpStorytellingEnabled,
    pdpStorytellingModuleOrder,
    product,
    sizingRecommendation: additionalSizingRecommendation || sizingRecommendation,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  setCurrentAttributeIndex: (index, origination, basicProductProperties) => {
    const { attributes } = ownProps;
    const accordionOpened = get(attributes, [index, 'header']);
    // this check prevents the event from sending when the accordion is closed
    index &&
      Rudderstack.detailsAccordionOpened({
        accordionOpened,
        ...basicProductProperties,
      });

    dispatch(actions.setCurrentAttributeIndex(index, origination));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Pdp);
